import { Alert, AlertTitle, Box, Button } from '@mui/material';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import PropertyNavbar from './PropertyNavbar';
import { Route, Routes } from "react-router-dom"
import Dashboard from './Dashboard/Dashboard';
import ReservationsPage from './Reservations/ReservationsPage';
import AvailabilityAndPricingPage from './Prices/AvailabilityAndPricingPage';
import { withQueryData } from '../../../common/withQueryData';
import RoomsPage from './Rooms/RoomsPage';

import Navigation from '../../../common/navigation/Navigation';
import ConfigurationPage from './Configuration/ConfigurationPage';
import { usePropertyData } from '../../../common/hooks/usePropertyId';
import { useDocumentBranding } from '../../../common/hooks/useDocumentBranding';

const QueryError = ({ error, onReload }) => {
    const navigate = useNavigate();

    const navigateToPropertiesPage = () => {
        navigate(`/properties`);
    }

    return <>
        <Alert severity="error">
            <AlertTitle>Error</AlertTitle>
            <div>{error.message}</div>
            <Button onClick={onReload} variant="contained">Reload</Button>
            <Button onClick={navigateToPropertiesPage} variant="contained">Go back to Properties</Button>
        </Alert>
    </>;
}

export const propertySubPages = [
    {
        id: 1,
        name: "dashboard",
        displayName: "Dashboard"
    },
    {
        id: 2,
        name: "rooms",
        displayName: "Rooms"
    },
    {
        id: 3,
        name: "reservations",
        displayName: "Reservations"
    },
    {
        id: 4,
        name: "availability-and-pricing",
        displayName: "Availability and Pricing"
    },
    {
        id: 5,
        name: "configuration",
        displayName: "Configuration"
    }
]

const getSubPageByName = (name) => {
    const subPageArr = propertySubPages.filter(subPage => subPage.name === name);
    return subPageArr.length ? subPageArr[0] : null;
}

const getSubPageComponent = (subPageName) => {
    switch (subPageName) {
        case "rooms":
            return RoomsPage;
        case "availability-and-pricing":
            return AvailabilityAndPricingPage;
        case "reservations":
            return ReservationsPage;
        case "configuration":
            return ConfigurationPage;
        case "dashboard":
        default:
            return Dashboard;
    }
}

const PropertyPage = () => {
    return <Routes>
        <Route exact path="/" element={<Navigate to="dashboard" />} />
        <Route path=":subPageName/*" element={<PropertyPageContent />} />
    </Routes>
}

const PropertyPageSubContent = ({ data: property, reload }) => {
    const { subPageName } = useParams();

    useDocumentBranding(property, { titleSuffix: ' – Panel' });

    const subPage = getSubPageByName(subPageName);

    const SubPageComponent = getSubPageComponent(subPage.name);

    return <>
        <Navigation title={property.name} logoUrl={property.logoUrl} />
        <PropertyNavbar property={property} value={subPage.id} />
        <Box id="propertyPageContent" style={{ flexGrow: 1, display: "flex", flexDirection: "column", position: 'relative' }}>
            <SubPageComponent property={property} />
        </Box>
    </>
}

const PropertyPageSubContentWithQueryData = withQueryData(
    PropertyPageSubContent,
    QueryError
)

const PropertyPageContent = () => {
    const { queryData } = usePropertyData();

    return <PropertyPageSubContentWithQueryData
        queryData={queryData}
    />
}

export default PropertyPage;